import { useParams } from "react-router-dom";
import { Flex, VStack } from "@chakra-ui/react";

import { useRegistrationConfirm } from "modules/authentication/infrastructure/useRegistrationConfirm";

import { SuccessWidget } from "components/Widgets";
import { ChakraText } from "components/ChakraText";
import { MainPageButton } from "components/MainPageButton";

import { TokenExpiredErrorBoundary } from "../Commons/TokenExpiredErrorBoundary";
import { AdditionalInformation } from "./AdditionalInformation";

const RegistrationConfirmationPageThrowable = () => {
  const { tokenId } = useParams<{
    tokenId: string;
  }>();

  const { data } = useRegistrationConfirm(tokenId);

  return (
    <>
      <SuccessWidget>
        <VStack spacing={0} ml={6}>
          <ChakraText fontSize={{ base: "xl", md: "2xl" }}>
            Dziękujemy za rejestrację w naszym systemie.
          </ChakraText>
          <ChakraText fontSize={{ base: "xl", md: "2xl" }}>
            Nowe konto zostało zweryfikowane poprawnie.
          </ChakraText>
        </VStack>
      </SuccessWidget>
      {data?.appointmentId ? (
        <AdditionalInformation appointmentId={data.appointmentId} />
      ) : (
        <Flex my={10} w="70%" mx="auto" justifyContent="center">
          <MainPageButton />
        </Flex>
      )}
    </>
  );
};

const RegistrationConfirmationPage = () => {
  return (
    <TokenExpiredErrorBoundary>
      <RegistrationConfirmationPageThrowable />
    </TokenExpiredErrorBoundary>
  );
};

export default RegistrationConfirmationPage;
